import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import PersonIcon from '@mui/icons-material/Person';
import SchoolIcon from '@mui/icons-material/School';
import EmailIcon from '@mui/icons-material/Email';

function RegistrationForm({ onSubmit }) {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [college, setCollege] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!name || !email || !college) {
            // Ensure the error message is a simple string
            setError("Please fill all fields.");
            return;
        }
        setError("");
        onSubmit({ name, email, college }); 
    };

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                // ❌ 1. NECESSARY CHANGE: Removed height: '100%'. App.js now manages the scrollable area height.
                py: 4
            }}
        >
            <Paper 
                elevation={8}
                sx={{ 
                    // 🌟 2. RECOMMENDED CHANGE: Separated vertical (py) and horizontal (px) padding.
                    // This reduces vertical padding to '2' on mobile (xs) to save space, 
                    // while keeping the desktop (md) padding at '6' for the original look.
                    px: { xs: 3, md: 6 }, 
                    py: { xs: 2, md: 6 }, 
                    
                    borderRadius: 2,
                    maxWidth: '500px',
                    width: '100%',
                }}
            >
                {/* Title Section */}
                <Box sx={{ borderBottom: '3px solid', borderColor: 'primary.main', pb: 2, mb: 3 }}>
                    <Typography variant="h4" align="center" sx={{ fontWeight: 700, color: 'primary.dark' }}>
                        Candidate Registration
                    </Typography>
                    <Typography variant="body1" align="center" color="text.secondary" sx={{ mt: 0.5 }}>
                        Enter your details to begin the BTech Assessment.
                    </Typography>
                </Box>
                
                <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
                    
                    {/* Name Field */}
                    <TextField
                        label="Full Name"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        size="medium"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                        InputProps={{
                            startAdornment: (
                                <PersonIcon color="action" sx={{ mr: 1 }} />
                            ),
                        }}
                    />
                    
                    {/* Email Field */}
                    <TextField
                        label="Email Address"
                        type="email"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        size="medium"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        InputProps={{
                            startAdornment: (
                                <EmailIcon color="action" sx={{ mr: 1 }} />
                            ),
                        }}
                    />
                    
                    {/* College Field */}
                    <TextField
                        label="College/University Name"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        size="medium"
                        value={college}
                        onChange={(e) => setCollege(e.target.value)}
                        required
                        InputProps={{
                            startAdornment: (
                                <SchoolIcon color="action" sx={{ mr: 1 }} />
                            ),
                        }}
                    />

                    {/* Error Message */}
                    {error && (
                        <Typography color="error" variant="body2" sx={{ mt: 2 }}>
                            {error}
                        </Typography>
                    )}

                    {/* Submit Button */}
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{ mt: 4, py: 1.5, fontSize: '1.2rem', fontWeight: 700 }}
                        disabled={!name || !email || !college}
                    >
                        Proceed to Assessment Landing
                    </Button>
                </Box>
            </Paper>
        </Box>
    );
}

export default RegistrationForm;